export default __webpack_public_path__ + "static/media/sort-alphabetical-ascending-default.f4438d0c.svg";